import { Grid, Card, CardContent } from "@mui/material";

import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import HealingIcon from "@mui/icons-material/Healing";
import EventNoteIcon from "@mui/icons-material/EventNote";
import AssignmentIcon from "@mui/icons-material/Assignment";

import "./sidebar.css";

const sidebarItems = [
	{
		title: "Member & Family",
		icon: <FamilyRestroomIcon />,
		component: <></>
	},
	{
		title: "Benefits",
		icon: <HealingIcon />,
		component: <></>
	},
	{
		title: "Enrollments & Events",
		icon: <EventNoteIcon />,
		component: <></>
	},
	{
		title: "Documents Upload",
		icon: <AssignmentIcon />,
		component: <></>
	}
];

const Sidebar: React.FC = (): JSX.Element => {
	return (
		<div className="profile-sidebar">
			<Card className="items-card">
				<CardContent>
					{sidebarItems.map((sidebarItem, index) => {
						const { title, icon } = sidebarItem;
						return (
							<div key={index}>
								<Grid container>
									<Grid item xl={2}>
										{icon}
									</Grid>
									<Grid item>{title}</Grid>
								</Grid>
							</div>
						);
					})}
				</CardContent>
			</Card>
		</div>
	);
};

export default Sidebar;
